import React from "react";
import LoaderButton from "../LoaderButton";
import AiUsageMeter from "./AiUsageMeter";

// Guidance only, no sample values: every customer's records and fields differ, so a fixed example fits nobody.
const TIPS = [
  "Name the kind of record you need, if you know it.",
  "Add a person, a place, a number or a year to narrow the search.",
  "Plain words are fine; they do not have to match the documents exactly.",
];

/**
 * Semantic Search criteria: a plain-language description of what to find. The parent runs the search through the
 * embedded ChatSearch component and shows the ranked documents in the shared grid.
 */
export default function SemanticSearchPanel({
  query,
  isLoading,
  hasResults,
  entitlement,
  onQueryChange,
  onSubmit,
  onClear,
}) {
  const canSubmit = Boolean(query && query.trim()) && !isLoading;
  return (
    <form
      id="semanticSearchControls"
      className="ds-panel ds-criteria"
      autoComplete="off"
      onSubmit={(event) => {
        event.preventDefault();
        if (canSubmit) onSubmit();
      }}
    >
      <div className="ds-panel-heading">
        <h2>Semantic search</h2>
        <p>
          Describe what you need in plain language. DocumentSync AI reads index
          values and document text, so the wording does not have to match
          exactly.
        </p>
      </div>

      <div className="ds-field">
        <label htmlFor="semanticSearchQuery">What are you looking for?</label>
        <textarea
          id="semanticSearchQuery"
          className="ds-textarea"
          rows={4}
          value={query || ""}
          placeholder="Describe the records you need: what, who or where, and when"
          onChange={(event) => onQueryChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey && canSubmit) {
              event.preventDefault();
              onSubmit();
            }
          }}
        />
      </div>

      <ul className="ds-tips" aria-label="Search tips">
        {TIPS.map((tip) => (
          <li key={tip}>{tip}</li>
        ))}
      </ul>

      <div className="ds-actions">
        <LoaderButton
          block
          bsClass="btn"
          disabled={isLoading}
          type="submit"
          isLoading={isLoading}
          text="Search with AI"
          loadingText="Searching..."
          className="ds-btn-primary searchResetbutton"
        />
        <button
          type="button"
          className="btn ds-btn-secondary searchResetbutton"
          onClick={onClear}
          title={hasResults ? "Clear these results and start a new search" : "Clear"}
        >
          {hasResults ? "New search" : "Clear"}
        </button>
      </div>

      <AiUsageMeter entitlement={entitlement} />
    </form>
  );
}
